var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.vname,"vid":_vm.vid,"rules":_vm.rules,"mode":_vm.mode,"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-field',{attrs:{"label":_vm.label,"message":_vm.showErrorMessage ? props.errors : [],"type":{
      'is-danger': props.errors[0],
      'is-success': _vm.showSuccess && props.valid
    },"expanded":_vm.expanded,"grouped":_vm.grouped}},[_vm._t("default",null,null,props)],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }